<template>
  <!-- 全部案件：2 -->
  <div>
    <CommitVue :mystatus="mystatus" ref="childComponent"></CommitVue>
  </div>
</template>

<script>
import CommitVue from './Commit.vue'
import { getMyCaseApi } from '../../api/case'
// import Select from "../../components/case/Select.vue";
// import List from "../../components/case/List.vue";
// import { resumeMixin } from "../../mixins/resumeMixin";
export default {
  name: 'allCase',
  // mixins: [],
  data() {
    return {
      next:false,
      mystatus: 2,
      list: [],
      loading: true,
      informationVo: {
        name: ''
      },
      isPage: true,
      query: {
        pageNum: 1,
        pageSize: 20,
        resPageNum: 1
      },
      typeCase: '',
      typeList: [],

      currentPage: 1,
      pageSize: 5
    }
  },
  created() {
    this.getvalue()
  },
  mounted() {},
  components: {
    CommitVue
  },
    beforeRouteLeave(to, from, next) {
     
        const type = 'CasePage'+this.mystatus;
        if(to.name=='bankruptdetail'||to.name=='caseinfo'||to.name=='bankinput'){
          this.$refs.childComponent.saveSearchCondition()
        
        }else{
          this.$refs.childComponent.clearSearchConditions()
        }
       
        next();
    },
    beforeRouteEnter(to, from, next) {
      // 通过 next 回调访问组件实例
      next(vm => {

        vm.$refs.childComponent.hqSearchConditions(from.name)
              
          });
        
    },
  methods: {
    getvalue() {//传值给父组件，
      this.$emit('value', this.next)
    },
  },
  computed: {}
}
</script>

<style lang="less" scoped>
</style>
